<template>

  <popup
    @on=""
    button-style="success"
    :button-type="buttonType"
    heading="Pay Invoice"
    buttonSize="mini"
    round
    button-size="normal"
    button-type="buttonType"
    button-text="Payment"
    button-icon="fa fa-dollar-sign"
  :disable-save="true"
  :disableButton="disabled">

  <div class="padded" style="text-align: left;">
    <el-alert show-icon type="info" title="Under Development" description="Still under design and development" />
    <el-row :gutter="8">
      <el-row>
        <h3>Payment</h3>&nbsp;&nbsp;
        <el-radio v-model="full" label="1">Full</el-radio>&nbsp;
        <el-radio v-model="full" label="0">Partial</el-radio>
      </el-row>

      <el-col :span="24">
        <el-form inline style="padding-top: 1.2em;">

            <date-input label="Date" v-model="item.datePaid" />
            <text-input label="Ref" v-model="item.paidRef" />
            <currency-input label="Amount" v-model="item.amountPaid" :disabled="!item.paid" />
            <currency-input label="Tax" v-model="item.taxPaid" :disabled="!item.paid" />
            <currency-input label="Total" v-model="totalPaid" disabled />
            <check-box v-model="autoAllocate">Allocate across {{this.full === '1' ? 'all items' : 'selected'}}?</check-box>

        </el-form>

      </el-col>

      <el-col :span="24">

        <el-row :gutter="8">
          <el-col :span="24">
          <el-transfer
            v-if="full === '0'"
            filterable
            :titles="['Line Items', 'Selected to Pay']"
            :filter-method="filterMethod"
            filter-placeholder="Refs"
            v-model="selected"
            :data="refs">
        </el-transfer>
      </el-col>

      </el-row>
    </el-col>


  </el-row>

</div>
</popup>

</template>

<script>

import PostMixins from '@/mixins/PostMixins'
import DateMixins from '@/mixins/DateMixins'

export default {
  mixins: [DateMixins, PostMixins],

  props: {
    rowData: {
      type: Object,
      required: true
    },

    disabled: {
      type: Boolean,
      default: false
    },

    buttonType: {
      type: String,
      default: 'default'
    }
  },

  methods: {
    paidDefaults () {

      if (this.item.paid) {

        if (!this.item.datePaid) {
          this.item.datePaid = new Date()
        }

        if (this.item.amountPaid <= 0.00) {
          this.item.amountPaid = this.item.total
        }

      }
    },

    filterMethod (query, item) {
      return item.initial.toLowerCase().indexOf(query.toLowerCase()) > -1
    }
  },

  computed: {
    totalPaid: function () {

      this.item.totalPaid = Number(this.item.amountPaid) + Number(this.item.taxPaid)

      return this.item.totalPaid
    }
  },


  data () {
    return {
      autoAllocate: true,
      full: '1',
      item: this.rowData,
      refs: [],
      selected: []
    }
  }
}

</script>
